/**
 * CompartilhamentoApp
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Motorista} from '@/model/resource/Motorista'
import {CompartilhamentoAppCollection} from '@/model/collection/CompartilhamentoAppCollection'

/* TODO: review generated class */
export class CompartilhamentoApp extends Resource {
  idCompartilhamentoAppPk: number = 0

  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  qtdCompartilhamento: number | null = null

  get $id() {
    return this.idCompartilhamentoAppPk
  }
  set $id(val) {
    this.idCompartilhamentoAppPk = val
  }

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(val) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = val
  }

  /**
   * Gets a instance of a given ID of CompartilhamentoApp
   */
  async getCompartilhamentoApp(id: number) {
    return await Request.get(`/admin/compartilhamento-app/${id}`)
      .name('getCompartilhamentoApp')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CompartilhamentoApp
   */
  static async listCompartilhamentoApp(params: any) {
    return await Request.get(`/admin/compartilhamento-app`, {params})
      .name('listCompartilhamentoApp')
      .as(CompartilhamentoAppCollection)
      .getData()
  }

  /**
   * Persists a new instance of CompartilhamentoApp. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCompartilhamentoApp() {
    return await Request.post(`/admin/compartilhamento-app`, this)
      .name('persistCompartilhamentoApp')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CompartilhamentoApp to use it in a CSV file
   */
  static async listCsvCompartilhamentoApp(params: any) {
    return await Request.get(`/admin/compartilhamento-app/csv`, {params})
      .name('listCsvCompartilhamentoApp')
      .as(CompartilhamentoAppCollection)
      .getData()
  }
}
